import Path from '../../../services/paths'
import utils from '../../common/utils'
import GeoAction from '../../prat_actions/gt/geoAction'

export default class GeoMiddleware {
    static get_regions(currentForm) {
        let url = currentForm === 'ic' ? Path.GET_ICE_CREAM_REGIONS : Path.GET_GEO_REGION
        return dispatch => {
            dispatch(GeoAction.geoRegions_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(GeoAction.geoRegions_Success(data))
                        })
                        .catch(err => {
                            dispatch(GeoAction.geoRegions_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(GeoAction.geoRegionss_Failed(err.message))

                })
        }
    };

    // GEO AREA

    static get_areas() {
        return dispatch => {
            dispatch(GeoAction.geoAreas_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_GEO_AREA, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(GeoAction.geoAreas_Success(data))
                        })
                        .catch(err => {
                            dispatch(GeoAction.geoAreas_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(GeoAction.geoAreas_Failed(err.message))

                })
        }
    };

    static get_towns() {
        return dispatch => {
            dispatch(GeoAction.geoTowns_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_GEO_TOWNS, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(GeoAction.geoTowns_Success(data))
                        })
                        .catch(err => {
                            dispatch(GeoAction.geoTowns_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(GeoAction.geoTowns_Failed(err.message))

                })
        };
    };

    static get_distributors() {
        return dispatch => {
            dispatch(GeoAction.geoDistributors_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_GEO_DISTRIBUTORS, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(GeoAction.geoDistributors_Success(data))
                        })
                        .catch(err => {
                            dispatch(GeoAction.geoDistributors_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(GeoAction.geoDistributors_Failed(err.message))

                })
        }
    };

    static get_direct_customer() {
        return dispatch => {
            dispatch(GeoAction.geoDirectcustomer_Request());
            utils.get_token()
                .then(token => {
                    fetch(Path.GET_DIRECT_CUSTOMER, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(GeoAction.geoDirectcustomer_Success(data))
                        })
                        .catch(err => {
                            dispatch(GeoAction.geoDirectcustomer_Failed(err.message))
                        })
                })
                .catch(err => {
                    dispatch(GeoAction.geoDirectcustomer_Failed(err.message))

                })
        }
    };

    //get distributors on selected resgions

    static get_distributorsOnResgions(selectedDirectCustomer,selectedRegions) {
        let url = `${Path.GET_GEO_DISTRIBUTORS_ON_RESGION}?`;
        if (Array.isArray(selectedRegions)) {
            selectedRegions.forEach(element => {
                url += `region=${element.value ? element.value : element}&`;
            });
        }
        if (Array.isArray(selectedDirectCustomer)) {
            selectedDirectCustomer.forEach(element => {
                url += `direct_customer=${element.value ? element.value : element}&`;
            });
        }
        // if (selectedDirectCustomer.length>0) {
        //     // selectedDirectCustomer.forEach(element => {
        //         url += `direct_customer=${selectedDirectCustomer.label ? selectedDirectCustomer.label : selectedDirectCustomer}`;
        //     // });
        // }

        return dispatch => {
            dispatch(GeoAction.geoDistributors_on_resgion_Request());
            utils.get_token()
                .then(token => {
                    fetch(url, {
                        method: 'GET',
                        headers: {
                            "Content-type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => res.json())
                        .then(data => {
                            dispatch(GeoAction.geoDistributors_on_resgion_Success(data))
                        })
                        .catch(err => {
                            dispatch(GeoAction.geoDistributors_on_resgion_Failed([]))
                        })
                })
                .catch(err => {
                    dispatch(GeoAction.geoDistributors_on_resgion_Failed([]))

                })
        }
    }

}

